export enum ReportType {
    Compliance,
    Detail,
    Score,
    Summary,
    Assessment,
    Wellness,
    Movement,
    WellnessSummary,
}
